<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { useDropdownContext } from './provider.js';

const props = defineProps({
  label: { type: String, default: '' },
  icon: { type: [String, Object, Function], default: '' },
  link: { type: [String, Object], default: '' },
  nativeLink: { type: Boolean, default: false },
  click: { type: Function, default: null },
  preserveOpen: { type: Boolean, default: false },
});

defineOptions({
  inheritAttrs: false,
});

const router = useRouter();
const { closeMenu } = useDropdownContext();

const componentIs = computed(() => {
  if (props.link) {
    if (props.nativeLink && typeof props.link === 'string') {
      return 'a';
    }
    return 'button';
  }
  if (props.click) return 'button';
  return 'div';
});

const triggerClick = () => {
  if (props.link && !props.nativeLink) {
    router.push(props.link);
  } else if (props.click) {
    props.click();
  }
  if (!props.preserveOpen) closeMenu();
};
</script>

<template>
  <li class="n-dropdown-item">
    <component
      :is="componentIs"
      v-bind="$attrs"
      class="flex text-left rtl:text-right items-center px-2 py-2 sm:py-1.5 reset-base text-sm text-n-slate-12 w-full border-0 cursor-pointer transition-colors duration-150"
      :class="{
        'hover:bg-black/[.06] dark:hover:bg-white/[.08] rounded-lg w-full gap-3': !$slots.default,
      }"
      :href="componentIs === 'a' ? props.link : null"
      @click="triggerClick"
    >
      <slot>
        <slot name="icon">
          <Icon
            v-if="icon"
            class="size-4 text-n-slate-11 flex-shrink-0"
            :icon="icon"
          />
        </slot>
        <slot name="label">
          <span class="truncate">{{ label }}</span>
        </slot>
      </slot>
    </component>
  </li>
</template>
